import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Stack } from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';
import { selectUserIsAdmin } from 'redux/reducers/authReducer';
import useSaveWarning from 'hooks/Home/useSaveWarning';
import useDeleteWarning from 'hooks/Home/useDeleteWarning';
import { Warning } from 'helper/home';
import WarningFormModal from './WarningFormModal';
import DeleteButton from './DeleteButton';

export default function Warnings({
  warnings,
  visible,
  updateLastSeen,
  refetch,
}: {
  warnings: Warning[];
  visible: boolean;
  updateLastSeen: () => void;
  refetch: () => void;
}) {
  const userIsAdmin = useSelector(selectUserIsAdmin);
  const {
    id,
    title,
    setTitle,
    message,
    setMessage,
    expirationTime,
    setExpirationTime,
    formHeader,
    formOpen,
    formValidated,
    openForm,
    closeForm,
    saveWarning,
  } = useSaveWarning(refetch);
  const {
    confirmDeletionBox,
    setConfirmDeletionBox,
    deleteWarning,
  } = useDeleteWarning(refetch);

  useEffect(() => {
    if (warnings && visible) updateLastSeen();
  }, [warnings, visible, updateLastSeen]);

  return (
    <div className="pt-1">
      {userIsAdmin && (
        <div className="mb-3 mx-3 d-flex justify-content-end">
          <WarningFormModal
            key={id}
            header={formHeader}
            title={title}
            setTitle={setTitle}
            message={message}
            setMessage={setMessage}
            expirationTime={expirationTime}
            setExpirationTime={setExpirationTime}
            show={formOpen}
            dismiss={closeForm}
            saveWarning={saveWarning}
            formValidated={formValidated}
          />
          {confirmDeletionBox}
          <Button onClick={() => openForm()} small>
            Novo Aviso
          </Button>
        </div>
      )}
      <div className="ht-row-container">
        {warnings.map((warning) => (
          <div key={warning.id} className="d-flex justify-content-between mx-3 py-2 border-bottom">
            <div className="flex-grow-1">
              <b>{`${warning.title}:`}</b>
              {` ${warning.message}`}
            </div>
            {userIsAdmin && (
              <Stack direction="horizontal" gap={2} className="align-self-start ms-3">
                <Button
                  small
                  icon="edit"
                  onClick={
                    () => openForm(
                      warning.id,
                      warning.title,
                      warning.message,
                      warning.expirationTime,
                    )
                  }
                />
                <DeleteButton
                  warningTitle={warning.title}
                  onConfirm={() => deleteWarning(warning.id)}
                  setConfirmationDialogBox={setConfirmDeletionBox}
                />
              </Stack>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
